// extracted by mini-css-extract-plugin
export default {"prize-announcement-wrapper":"krtkAX73s2ySSvt_yE3s","prize-announcement":"zKOx_ozsrZxCtDTrwf1r","prize-announcement--copy":"Qe01LkjUzHZ4K2hq8beE"};